export function insertArray(arr: any[], element: any, toIndex: number): any[] {
    var newArr = arr;

    newArr.splice(toIndex, 0, element);

    return newArr;
}
